import React from 'react';
import {
    ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend
} from 'recharts';

const Graph = ({ data }) => {
    return (
        <ResponsiveContainer width={'100%'} height={300}>
            <LineChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5, right: 10, left: 10, bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="hour" />
                <YAxis yAxisId="left" />
                <Tooltip/>
                <Legend/>
                <Line yAxisId="left" type="linear" dataKey="requests" stroke="#5c00e6" dot={{ stroke: '#5c00e6', strokeWidth: 3 }} activeDot={{ stroke: '#5c00e6', strokeWidth: 3 }} strokeWidth={3} />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default Graph;


// WEBPACK FOOTER //
// ./src/scenes/AdkPartnerGraph/components/GraphRequests/index.js